import { Annotation, KnownCloud, KnownUser } from '@readcloud/data';
import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import {
  SelectableObjectItem,
  SelectableObjectsList,
} from '../SelectableObjectsList';

const peopleTab = 0;
const cloudsTab = 1;

function SharingPopover(props: {
  annotation: Annotation;
  onChange: (anno: Annotation) => void;
  knownClouds: KnownCloud[];
  knownUsers: KnownUser[];
}) {
  const [sharingTab, setSharingTab] = React.useState(peopleTab);
  const handleTabChange = React.useCallback((value: unknown) => {
    if (typeof value === 'number') {
      setSharingTab(value);
    }
  }, []);
  const handleKnownUsersChange = React.useCallback(
    (ids: string[]) => {
      props.onChange({
        ...props.annotation,
        visibleToUsers: ids,
      });
    },
    [props.onChange, props.annotation]
  );
  const handleKnownCloudsChange = React.useCallback(
    (ids: string[]) => {
      props.onChange({
        ...props.annotation,
        visibleInClouds: ids,
      });
    },
    [props.onChange, props.annotation]
  );

  const knownUsersItems = React.useMemo<SelectableObjectItem[]>(
    () =>
      props.knownUsers.map((user) => ({
        avatarName: `${user.firstName} ${user.lastName}`,
        primaryText: `${user.firstName} ${user.lastName}`,
        secondaryText: user.email,
        id: user.id,
      })),
    [props.knownUsers]
  );
  const knownCloudsItems = React.useMemo<SelectableObjectItem[]>(
    () =>
      props.knownClouds.map((cloud) => ({
        avatarName: cloud.name,
        primaryText: cloud.name,
        secondaryText: cloud.institution,
        id: cloud.id,
      })),
    [props.knownClouds]
  );

  return (
    <div>
      {knownCloudsItems.length && knownUsersItems.length ? (
        <Tabs
          className="rc-justify-center"
          defaultActiveKey={sharingTab}
          onSelect={handleTabChange}
        >
          <Tab
            key="people"
            tabClassName="rc-relative"
            title={
              <>
                {props.annotation.visibleToUsers.length > 0 && (
                  <div className="rc-absolute rc-flex rc-justify-center rc-items-center rc-w-6 rc-h-6 rc-bg-primary rc-rounded-full rc-text-light rc--top-1 rc-right-0 rc-leading-4">
                    {props.annotation.visibleToUsers.length}
                  </div>
                )}
                <div className="rc-py-2">Users</div>
              </>
            }
            eventKey={0}
          >
            <div className="rc-flex rc-items-center rc-pb-2 rc-pt-4">
              <SelectableObjectsList
                items={knownUsersItems}
                selectedItems={props.annotation.visibleToUsers}
                setSelectedItems={handleKnownUsersChange}
                selectAllObjectName="Users"
              />
            </div>
          </Tab>
          <Tab
            tabClassName="rc-relative"
            key="clouds"
            title={
              <>
                {props.annotation.visibleInClouds.length > 0 && (
                  <div className="rc-absolute rc-flex rc-justify-center rc-items-center rc-w-6 rc-h-6 rc-bg-primary rc-rounded-full rc-text-light rc--top-1 rc-right-0 rc-leading-4">
                    {props.annotation.visibleInClouds.length}
                  </div>
                )}
                <div className="rc-py-2">Clouds</div>
              </>
            }
            eventKey={1}
          >
            <div className="rc-flex rc-w-full rc-items-center rc-pb-2 rc-pt-4">
              <SelectableObjectsList
                items={knownCloudsItems}
                selectedItems={props.annotation.visibleInClouds}
                setSelectedItems={handleKnownCloudsChange}
                selectAllObjectName="Clouds"
              />
            </div>
          </Tab>
        </Tabs>
      ) : null}
    </div>
  );
}

export { SharingPopover };
